import { FC } from 'react'
import { Button as UiButton, IconButton } from '@cargomart/ui'
import IconArrowLeft from 'remixicon/icons/Arrows/arrow-left-line.svg?react'
import IconMobileFilter from 'remixicon/icons/System/filter-3-line.svg?react'
import IconSearch from 'remixicon/icons/System/search-line.svg?react'

import { OrderFilterSearchInput } from './OrderFilterSearchInput'

export interface OrderFilterMobileFilterTriggerProps {
  allFilterLength: number | undefined
  hasBadge: boolean
  isSearchMode: boolean
  isTablet: boolean | undefined
  onFilterClick: () => void
  onOpenFilterModalClick: () => void
  onSearchClick: () => void
  onSetSearch: (search: string) => void
  search: string
}

export const OrderFilterMobileFilterTrigger: FC<OrderFilterMobileFilterTriggerProps> = ({
  isTablet,
  allFilterLength,
  hasBadge,
  onSearchClick,
  onFilterClick,
  isSearchMode,
  onOpenFilterModalClick,
  onSetSearch,
  search
}) => (
  <div className="mt-4 flex gap-4">
    {isSearchMode ? (
      <>
        <IconButton outline onClick={onFilterClick} size={isTablet ? 'lg' : 'nm'}>
          <IconArrowLeft size={isTablet ? 'nm' : 'sm'} />
        </IconButton>
        <OrderFilterSearchInput
          className="flex grow flex-col md:w-[480px] md:grow-0"
          inputClassName="w-full"
          onSetSearch={onSetSearch}
          search={search}
          size={isTablet ? 'lg' : 'nm'}
        />
      </>
    ) : (
      <>
        <IconButton outline onClick={onSearchClick} size={isTablet ? 'lg' : 'nm'}>
          <IconSearch size={isTablet ? 'nm' : 'sm'} />
        </IconButton>
        <UiButton
          className="relative flex grow md:grow-0"
          onClick={onOpenFilterModalClick}
          prefix={<IconMobileFilter size="xs" />}
          size={isTablet ? 'lg' : 'nm'}
          variant="outline"
          postfix={
            <>
              {hasBadge && (
                <div className="absolute -right-2 -top-2 z-10 flex h-[20px] w-[20px] items-center justify-center rounded-[50%] bg-primary text-body-sm text-surface">
                  {allFilterLength}
                </div>
              )}
            </>
          }
        >
          Фильтры
        </UiButton>
      </>
    )}
  </div>
)
